import React from "react";

const CloseSvg = () => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Close modal</title>
      <path
        d="M6.00062 7.46595L1.35037 12.1164C1.22341 12.2432 1.06384 12.3082 0.871642 12.3112C0.6796 12.3141 0.517121 12.2492 0.384204 12.1164C0.251441 11.9835 0.185059 11.8225 0.185059 11.6333C0.185059 11.4442 0.251441 11.2832 0.384204 11.1503L5.03468 6.50001L0.384204 1.84976C0.257399 1.7228 0.192468 1.56323 0.189413 1.37103C0.18651 1.17899 0.251441 1.01651 0.384204 0.883594C0.517121 0.75083 0.678149 0.684448 0.867288 0.684448C1.05643 0.684448 1.21745 0.75083 1.35037 0.883594L6.00062 5.53407L10.6509 0.883594C10.7778 0.756789 10.9374 0.691858 11.1296 0.688802C11.3216 0.6859 11.4841 0.75083 11.617 0.883594C11.7498 1.01651 11.8162 1.17754 11.8162 1.36668C11.8162 1.55582 11.7498 1.71684 11.617 1.84976L6.96656 6.50001L11.617 11.1503C11.7438 11.2772 11.8088 11.4368 11.8118 11.629C11.8147 11.821 11.7498 11.9835 11.617 12.1164C11.4841 12.2492 11.3231 12.3156 11.134 12.3156C10.9448 12.3156 10.7838 12.2492 10.6509 12.1164L6.00062 7.46595Z"
        className="fill-[#1C1B1F] dark:fill-white"
      />
    </svg>
  );
};

export default CloseSvg;
